// extracted by mini-css-extract-plugin
module.exports = {"badge":"_1eefbb2c","badgeMedium":"_ab525ad1","badgeNeutral":"_94363999","badgeAlert":"_79db98a2","badgeLink":"_d1ceb70c","badgeInner":"_efd2e492","badgeInnerMedium":"_b9d28b4f"};